import { ComponentProps } from 'react';
import { DropDown } from '../../../commons/DropDown';

export const dropDownClassNames: ComponentProps<
  typeof DropDown
>['classNames'] = {
  container: prev =>
    prev
      .split(' ')
      .filter(
        s =>
          !/^border(-.*)?/.test(s) &&
          !/^bg-.*/.test(s) &&
          !/^h-.*/.test(s) &&
          !/^text-.*/.test(s) &&
          !/^px?y?r?l?b?t?-.*/.test(s)
      )
      .concat(['text-lg', 'text-bluegray-700', 'pl-4'])
      .join(' '),
  select: prev => `${prev} font-bold bg-transparent py-1 pl-3 text-lg`,
  dropdownIcon: prev => `${prev} text-2xl text-bluegray-700`,
};
